import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Support',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    SelectFromList: require('@/components/selectFromList/selectFromList.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      firstBoot: true,
      support: {
        additionalCost: 0,
        comment: '',
        dt: moment(new Date()).format(),
        id: 0,
        logDescription: '',
        logValue: 0,
        name: '',
        rateHr: 0,
        supportService: '',
        supportServiceId: 0,
        supportServiceType: '',
        supportServiceTypeId: 0,
        totalCost: 0,
        travelDistance: 0,
        travelDuration: 0,
        workDuration: 0
      },
      supportServicesAll: [],
      supportService: { text: '', value: '' },
      supportServiceTypes: [],
      supportServiceType: { text: '', value: '' },
      allTeams: [],
      team: { text: '', value: '' },
      teamId: -1,
      stations: [],
      station: { text: '', value: '' },
      stationId: -1,
      selection: [],
      rateKey: 0,
    }
  },
  validations: {
    supportService: {
      required
    },
    supportServiceType: {
      required
    },
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    teams: function () {
      if (this.station.value == -1) //all option
        return this.allTeams;
      else {
        let temp = this.allTeams.filter(t => t.group !=null && t.group.id == this.station.value);
        if (temp && temp.length > 0)
          temp.unshift(this.allTeams[0]);

        return temp;
      }
    },
    supportServices: function () {
      let supportServices = [...this.supportServicesAll];

      if (this.station.value > -1)
        supportServices = supportServices.filter(p => p.stationId == this.station.value);

      if (this.team.value > -1)
        supportServices = supportServices.filter(p => p.teamId == this.team.value);

      if (this.supportServiceType.value > 0)
        supportServices = supportServices.filter(p => p.supportServiceTypeId == this.supportServiceType.value);

      return supportServices;
    },
  },
  watch: {
    selectionCount: function (value) {
      this.dataObj.selection = [];
      if (value === 0)
        return;

      this.selection.forEach(p => this.dataObj.selection.push({
        id: p.id,
        supportServiceTypeId: p.supportServiceTypeId,
        rate: p.rateHr,
      }));
      this.calculateCost();
    },
    team: function (value) {
      if (!value)
        return;

      this.teamId = parseInt(value.value);

      this.resetDropDowns('team');
    },
    station: function (value) {
      if (!value)
        return;

      this.dataObj.stationId = value.value;
      this.stationId = parseInt(value.value);

      this.resetDropDowns();
    },
    supportServiceType: function (value) {
      if (!value)
        return;

      this.dataObj.supportServiceTypeId = value.value;
    },
    "supportService.id": function (value) {
      this.dataObj.supportServiceId = value;
    }
  },
  created() {
    console.log("clone support", this.dataObj);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.support = this.dataObj;
        this.supportServicesAll = this.dataObj.supportServices;
        //this.supportServices = this.supportServicesAll.filter(p => p.supportServiceTypeId === this.support.supportServiceTypeId.toString());
        if (this.supportServicesAll && this.supportServicesAll.length > 0)
          this.supportService = this.supportServicesAll.filter(p => p.id == this.dataObj.supportServiceId)[0];

        this.supportServiceTypes = this.dataObj.supportServiceTypes;
        if (this.dataObj.supportServiceTypeId != null && this.dataObj.supportServiceTypeId != '' && this.dataObj.supportServiceTypeId >= 0)
          this.dataObj.supportServiceTypeId = this.dataObj.supportServiceTypeId.toString();
        else if (this.supportServiceTypes && this.supportServiceTypes.length > 0)
          this.dataObj.supportServiceTypeId = this.supportServiceTypes[0].value;

        if (this.supportServiceTypes && this.supportServiceTypes.length > 0)
          this.supportServiceType = this.supportServiceTypes.filter(p => p.value == this.dataObj.supportServiceTypeId)[0];

        this.allTeams = this.dataObj.teams;
        this.stations = this.dataObj.stations;

        if (this.dataObj.rateHr == null || this.dataObj.rateHr == 0)
          this.firstBoot = false;
        else
          this.support.rateHr = this.dataObj.rateHr;
        //console.log("sup r", this.support.rateHr);

        let stationList;

        //add default value to station
        if (this.dataObj.applicationStationId >= -1) {
          stationList = this.stations.filter(s => s.value == this.dataObj.applicationStationId);
          if (stationList && stationList.length > 0) {
            this.station = stationList[0];
            this.stationId = this.station.value;
          }
        }

        if (!stationList) {
          this.station = this.stations[0];
          this.stationId = this.stations[0].value;
        }

        //find employee
        let employee;
        if (this.dataObj.assignedEmployeeId >= 0) {
          let emp = this.dataObj.employees.filter(e => e.employeeId == this.dataObj.assignedEmployeeId);
          employee = emp && emp.length > 0 ? emp[0] : null;
        }

        //add default value to team
        let teamList;
        if (this.teams && this.teams.length > 0) {
          if (employee && employee.teamId != null && employee.teamId >= 0) {
            teamList = this.allTeams.filter(t => t.value == employee.teamId);
            if (teamList && teamList.length > 0) {
              this.team = teamList[0];
              this.teamId = this.team.value;
            }
          }
        }

        if (!this.teams || this.teams.length == 0 || !teamList) {
          this.team = this.teams[0];
          this.teamId = this.teams[0].value;
        }  
      });
    },
    resetDropDowns(type = 'all') {
      if (type == 'all')
        this.team = this.teams && this.teams.length > 0 ? this.allTeams[0] : {};

      this.selection = [];
      this.employee = {};

    },
    calculateCost() {
      let total = 0;
      if (parseInt(this.support.workDuration) < 0 || isNaN(parseInt(this.support.workDuration))) {
        this.support.workDuration = 0;
        return;
      }
      if (parseInt(this.support.travelDuration) < 0 || isNaN(parseInt(this.support.travelDuration))) {
        this.support.travelDuration = 0;
        return;
      }
      if (parseInt(this.support.travelDistance) < 0 || isNaN(parseInt(this.support.travelDistance))) {
        this.support.travelDistance = 0;
        return;
      }
      if (this.dataObj.isMultiple === true) {
        this.selection.forEach(p => {
          total = total + (this.support.workDuration * parseFloat(p.rateHr) / 60 + this.support.travelDuration * parseFloat(p.rateHr) / 60)
        });
        this.dataObj.selection = [];
        this.selection.forEach(p => this.dataObj.selection.push({
          id: p.id,
          supportServiceTypeId: p.supportServiceTypeId,
          rate: p.rateHr,
        }));
      }
      else {
        total = this.support.workDuration * this.support.rateHr / 60 + this.support.travelDuration * this.support.rateHr / 60;
      }
      
      this.support.totalCost = total.toFixed(2);
    },
    setSelectedSupportService(value) {
      this.support.supportService = this.supportServices.filter(p => p.id === value)[0].name;
    },
    setSelectedServiceType(value) {
      this.support.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0].text;
      this.supportServiceType = this.supportServiceTypes.filter(p => p.value === value)[0];
    },
    setSelectedTeam(value) {
    },
    setSelectedStation(value) {

    },
  },
}

